import React from "react";
import {
  GridColumnMenuFilter,
  GridColumnMenuSort,
  GridColumnMenuProps,
} from "@progress/kendo-react-grid";

const ColumnMenu = (props: GridColumnMenuProps) => {
  return (
    <div>
      <GridColumnMenuSort {...props} />
      <GridColumnMenuFilter {...props} />
    </div>
  );
};

export default ColumnMenu;
